















































import { Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import * as helper from '@/assets/_js/helpers'
import { Package } from 'dapp-client'

const numeral = require('numeral')

@Component
export default class PrvTableRow extends Vue {
  // props
  @Prop() dsp!: any
  @Prop() index!: number

  // data
  private numeral = numeral
  private pkgJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }
  private dspJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }

  // computed
  get statextTable() {
    return vxm.dappservices.statextTable
  }

  get pkg() {
    return this.dsp.packages[0]
  }

  get getNameLogo() {
    return helper.nameLogo(this.dsp.provider, this.pkgJson, this.dspJson)
  }
  // method

  // Lifecycle hooks
  async mounted() {
    if (this.pkg && this.pkg.package_json_uri) {
      let pkgJson = await vxm.jsondb.getPkgJson(this.pkg)
      let dspJson = await vxm.jsondb.getDspJson(this.pkg)
      this.pkgJson = pkgJson
      this.dspJson = dspJson
    }
  }
  created() {}
  async updated() {
    if (this.pkg && this.pkg.package_json_uri) {
      let pkgJson = await vxm.jsondb.getPkgJson(this.pkg)
      let dspJson = await vxm.jsondb.getDspJson(this.pkg)
      this.pkgJson = pkgJson
      this.dspJson = dspJson
    }
  }
  destroyed() {}
}
